<template>
  <div class="marketing-automation-form-panel-section">
    <div v-if="title"
         class="marketing-automation-form-panel-section-title">{{ title }}</div>

    <slot />
  </div>
</template>

<script>
export default {
  components: {},

  props: {
    title: {
      type: String,
    },
  },

  computed: {},

  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-form-panel-section {
  padding: 15px 10px;
  border-bottom: 2px solid $grey-1;

  .marketing-automation-form-panel-section-title {
    margin-bottom: 15px;
    font-weight: 600;
    color: #4d4f5c;
  }

  &:last-child {
    border-bottom: none;
  }
}
</style>
